export default {
  install(Vue){
    Vue.filter('htmlImage', (v, k = 'relativePath')=> {
      if (!v) return "";
      if (dsf.isString(v)) {
        try {
          v = JSON.parse(v);
        } catch (e) {
          return createImage(v);
        }
      }
      if (dsf.isObject(v)) {
        v = [v];
      }
      return v.map(item => {
        return createImage(item[k]);
      }).join('');
    })
  }
}

function createImage(url) {
  url = dsf.url.getWebPath(url);
  return `<img class="proxy-img" src="${url}" style="max-width: 100%;max-height: 100%;" />`
}